"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobile_token_pin_png_1 = __importDefault(require("../../../../assets/img/mobile-token-pin.png"));
const ico_close_png_1 = __importDefault(require("../../../../assets/img/ico-close.png"));
const bg_wid_gradient_png_1 = __importDefault(require("../../../../assets/img/bg_wid_gradient.png"));
const styles_1 = require("@mui/styles");
const fontFamilyConst = '"Open Sans", Helvetica,Arial,sans-serif';
const paddingConst = '6px 10px 8px';
exports.default = (0, styles_1.makeStyles)(() => ({
    dialog: {
        borderRadius: '5px',
        borderWidth: '0px',
        color: '#2f3c54',
        marginTop: '-160px',
        fontFamily: fontFamilyConst,
        background: `url(${bg_wid_gradient_png_1.default}) repeat-x left bottom #fff`,
        overflow: 'hidden'
    },
    DialogContentOuter: {
        width: '420px',
        backgroundColor: '#f7f7f7',
        paddingTop: '10px'
    },
    DialogNotification: {
        position: 'absolute'
    },
    DialogContent: {
        borderWidth: 0,
        width: '400px',
        height: '170px',
        overflow: 'hidden',
        position: 'relative',
        padding: paddingConst
        // position: 'relative'
    },
    WrapIcon: {
        position: 'relative',
        background: `url(${mobile_token_pin_png_1.default}) no-repeat`,
        width: 75,
        height: 180,
        display: 'block',
        marginTop: '101px',
        marginRight: '5px'
    },
    IconClose: {
        position: 'relative',
        background: `url(${ico_close_png_1.default}) no-repeat`,
        backgroundSize: 'contain',
        width: 16,
        height: 16,
        marginRight: '5px',
        display: 'block',
        marginTop: '2px',
        cursor: 'pointer',
        zIndex: 1103
    },
    ListItem: {
        marginTop: '-60px',
        overflow: 'hidden',
        padding: paddingConst,
        position: 'relative',
        marginLeft: '-10px',
        width: '403px',
        height: '217px'
    },
    ListItemText: {
        width: '282px',
        height: '87px',
        fontSize: '14px',
        fontWeight: 'normal',
        padding: 0,
        color: '#2f3c54'
    },
    text: {
        padding: '38px'
    },
    typography: {
        'font-size': '14px',
        'margin-left': '-5px',
        'word-break': 'break-all',
        'margin-top': '-1px',
        color: '#2f3c54',
        fontWeight: 'normal',
        fontFamily: fontFamilyConst,
        width: '285px'
    },
    note2: {
        'margin-top': '-13px',
        width: '276px'
    },
    OneTokenTitle: {
        color: '#2f3c54',
        fontWeight: 'bold',
        margin: '10px 10px 0',
        padding: '5px 0 10px',
        fontSize: '103%',
        marginTop: '15px',
        marginLeft: '19px',
        fontFamily: fontFamilyConst,
        fontStyle: 'normal',
        width: '352px'
    },
    Link: {
        color: '#1480b7',
        textDecoration: 'underline',
        fontSize: '12px',
        fontWeight: 600,
        marginLeft: '-5px',
        fontFamily: fontFamilyConst,
        cursor: 'pointer'
    },
    OTPLink: {
        color: '#1480b7',
        textDecoration: 'underline',
        fontSize: '12px',
        fontWeight: 600,
        marginLeft: '-5px',
        fontFamily: fontFamilyConst,
        cursor: 'pointer',
        paddingLeft: '4px'
    },
    resendNotification: {
        margin: '10px 10px 0 10px',
        borderTop: '1px solid #d9dadd',
        position: 'relative',
        paddingBottom: '42px',
        width: '380px',
        height: '15px',
        paddingTop: '10px',
        display: 'block',
        fontSize: '12px',
        fontWeight: 'normal',
        marginLeft: '-5px'
    }
}));
